import { CSSProperties } from 'react';
import merge from 'lodash/merge';
import styled, { CSSObject } from 'styled-components';
import { breakpoint, BreakpointProp } from '../../utils/styles/breakpoints';
import { spacing } from '../../utils/styles/spacing';
import { Box, type BoxProps } from './Box';

export interface FlexProps extends BoxProps {
    inline?: boolean;
    spacing?: BreakpointProp<number>;
    direction?: BreakpointProp<CSSProperties['flexDirection']>;
    alignItems?: BreakpointProp<CSSProperties['alignItems']>;
    alignSelf?: BreakpointProp<CSSProperties['alignSelf']>;
    justifyContent?: BreakpointProp<CSSProperties['justifyContent']>;
    justifySelf?: BreakpointProp<CSSProperties['justifySelf']>;
    flexWrap?: BreakpointProp<CSSProperties['flexWrap']>;
    flexBasis?: BreakpointProp<CSSProperties['flexBasis']>;
    flexGrow?: BreakpointProp<CSSProperties['flexGrow']>;
    flexShrink?: BreakpointProp<CSSProperties['flexShrink']>;
    whiteSpace?: BreakpointProp<CSSProperties['whiteSpace']>;
}

const flexProps = [
    'inline',
    'spacing',
    'direction',
    'alignItems',
    'alignSelf',
    'justifyContent',
    'justifySelf',
    'flexWrap',
    'flexBasis',
    'flexGrow',
    'flexShrink',
    'whiteSpace',
];

const flexModelStyles = (props: FlexProps): CSSObject =>
    merge(
        breakpoint('flexDirection', props.direction),
        breakpoint('alignItems', props.alignItems),
        breakpoint('alignSelf', props.alignSelf),
        breakpoint('justifyContent', props.justifyContent),
        breakpoint('justifySelf', props.justifySelf),
        breakpoint('gap', props.spacing, spacing),
        breakpoint('flexBasis', props.flexBasis),
        breakpoint('flexWrap', props.flexWrap),
        breakpoint('flexGrow', props.flexGrow),
        breakpoint('flexShrink', props.flexShrink),
        breakpoint('whiteSpace', props.whiteSpace),
    );

export const Flex = styled(Box)
    .withConfig({
        displayName: 'Flex',
        shouldForwardProp: (prop) => flexProps.indexOf(prop) === -1,
    })
    .attrs<FlexProps>((props) => ({
        ...props,
        display: props.inline ? 'inline-flex' : 'flex',
    }))<FlexProps>(flexModelStyles);

Flex.defaultProps = {
    direction: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
};
